export const accommodationTileDataMock = {
    id: '1001676',
    name: 'Apartamenty Centrum Warszawa',
    source: 'nop',
    type: 'Apartment',
    types: ['Apartment'],
    rating: {
        ratingDescription: 'sensational',
        ratingCount: 35,
        ratingsAverage: 9.6,
    },
    location: {
        settlement: {
            id: 756135,
            name: 'Warszawa',
        },
        latitude: 52.234230041503906, // or lat
        longitude: 21.012008666992188, // or lon
        address: 'Sienkiewicza ulica', // not used at the moment
        streetNumber: '4/23', // not used at the moment
        postalCode: '00-015', // not used at the moment
        currency: 'PLN',
        isNocClone: false,
    },
    features: {
        internalLabel: {
            reservationType: 'RealTime',
        },
        internalAmenityGroups: [
            // display order: parking, pool, jacuzzi, sauna, playground, pets, wifi - not sure whether it should be sorted on backend on frontend
            {
                label: 'Kuchnia',
                type: 'Kitchen',
                free: null,
            },
            {
                label: 'Przyjazny zwierzętom',
                type: 'PetFriendly',
                free: null,
            },
            {
                label: 'WiFi',
                type: 'Wifi',
                free: null,
            },
            {
                label: 'Telewizor',
                type: 'Tv',
                free: null,
            },
            {
                label: 'Sauna',
                type: 'Sauna',
                free: null,
            },
            {
                label: 'Jacuzzi',
                type: 'Jacuzzi',
                free: null,
            },
            {
                label: 'Plac zabaw',
                type: 'ChildrensArea',
                free: null,
            },
            {
                label: 'Parking',
                type: 'Parking',
                free: true,
            },
        ],
        promoText:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the', // ABO only
        bestseller: false,
        flagged: true,
    },
    images: [
        // currently we only need one, but in the future we'll need to display more (up to 10)
        {
            default: true,
            id: 29458760,
            url: 'https://images.pubsandbox.szallas.dev/hotels/1001676/original/29458760.jpg',
        },
    ],
    path: '/rezerwuj/1001676-apartamenty-centrum-warszawa/',
    rate: {
        apartment: {
            name: 'Apartament 4-osobowy',
            roomType: 'Apartament', // ROOM_TYPE options to be displayed: Pokój, Rezydencja, Apartament, Domek (used for all NOP “Domek” types: letniskowy / całoroczny / drewniany / weekendowy), Willa, Bungalow,  Agroturystyka (instead of “Gospodarstwo agroturystyczne” in NOP), Dom (instead of “Cały dom” in NOP”)
            size: 33,
            singleBeds: 2,
            doubleBeds: 1,
        },
        discount: 5,
        baseRate: 999,
        rate: 949.05,
        convertedBaseRate: 999,
        convertedRate: 949.05,
        convertedCurrency: 'PLN',
        checkIn: '2026-01-31',
        checkOut: '2026-02-05',
        guests: 3,

        provision: {
            name: 'Śniadania',
            type: 'Breakfast',
        },
        cancellationPolicy: {
            freeCancellation: true,
            notRefundable: false,
            cancellationDateTo: '2025-12-20',
        },
        prepayment: {
            rate: 119,
            convertedRate: 119,
            fullPrepayment: false,
        },
    },
    foreignPartnerId: -1,
    listing: {
        placement: 'Guarantee', // Guaranteed Position
        url: '/noclegi/warszawa',
    },
    // possibly more data needed for SEO/tracking purposes
};
